import React, { useState } from "react";
import { ActivateResult } from "./homeLicence";
import { isNativeApp } from "./nativeApp";

interface LicenceFormProps {
  activate: (code: string) => Promise<ActivateResult>;
  onActivated?: () => void;
}

const PROBLEMS: Record<Exclude<ActivateResult, "ok">, string> = {
  notFound: "We couldn't find that code. Check it against your Polar account page and try again.",
  inUse:
    "This code is in use on another tablet, and one code works on one tablet. To move it here, tap Remove this tablet in the other tablet's Settings, or remove the tablet on your Polar account page.",
  ended: "This code has ended, so it can't be used any more. A new subscription comes with a new code.",
  offline: "We couldn't reach the internet. Check the Wi-Fi and try again.",
};

// Entering a Masjid 24/7 Home code. The app only takes a code: Google charges its fee on anything
// bought through an app, so where to buy is shown in a browser only.
const LicenceForm: React.FC<LicenceFormProps> = ({ activate, onActivated }) => {
  const [code, setCode] = useState("");
  const [checking, setChecking] = useState(false);
  const [problem, setProblem] = useState<string | null>(null);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!code.trim() || checking) return;
    setChecking(true);
    setProblem(null);
    const result = await activate(code);
    setChecking(false);
    if (result === "ok") onActivated?.();
    else setProblem(PROBLEMS[result]);
  };

  return (
    <form className="hs-licence" onSubmit={submit}>
      <div className="hs-picker-bar">
        <input
          className="hs-input hs-code-input"
          value={code}
          onChange={(e) => setCode(e.target.value)}
          placeholder="Your code"
          aria-label="Your code"
          autoComplete="off"
          autoCapitalize="characters"
          spellCheck={false}
        />
        <button className="hs-button hs-primary" type="submit" disabled={checking || !code.trim()}>
          {checking ? "Checking…" : "Activate"}
        </button>
      </div>
      {problem && (
        <p className="hs-problem" role="alert">
          {problem}
        </p>
      )}
      <p className="hs-note">
        Where's my code? Open your Masjid 24/7 Home receipt email and tap <strong>Access purchase</strong>.
      </p>
      {!isNativeApp() && (
        <p className="hs-note">
          Get a code at <strong>masjid247.com/home</strong>.
        </p>
      )}
    </form>
  );
};

export default LicenceForm;
